// Opening a WhatsApp chat, with the choice between WhatsApp and WhatsApp
// Business on Android.
//
// A web page can't see which apps are installed. What it can do on Android is
// open a *specific* app with an intent link; if that app isn't there, Chrome
// follows the fallback URL (wa.me), which opens whichever WhatsApp the phone
// has. So on Android we offer both and let the member pick. iOS has no way to
// target one app, so there it is just wa.me.

// wa.me wants E.164 digits with country code (no +). Default US country code.
export const waDigits = (p) => {
  const d = String(p || "").replace(/\D/g, "");
  return d.length === 10 ? `1${d}` : d;
};

export const isAndroid = () =>
  typeof navigator !== "undefined" && /android/i.test(navigator.userAgent);

export const WA_APPS = [
  { key: "whatsapp", label: "WhatsApp", pkg: "com.whatsapp" },
  { key: "business", label: "WhatsApp Business", pkg: "com.whatsapp.w4b" },
];

export function whatsappHref(phone, appKey = null) {
  const d = waDigits(phone);
  const web = `https://wa.me/${d}`;
  const app = WA_APPS.find((a) => a.key === appKey);
  if (!app || !isAndroid()) return web;
  return `intent://send/?phone=${d}#Intent;scheme=whatsapp;package=${app.pkg};S.browser_fallback_url=${encodeURIComponent(web)};end`;
}

export function openWhatsApp(phone, appKey = null) {
  const href = whatsappHref(phone, appKey);
  if (href.startsWith("intent:")) window.location.href = href;
  else window.open(href, "_blank", "noopener,noreferrer");
}
